"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Offers = exports.Offer = exports.ADSOffer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var Shapes = _interopRequireWildcard(require("../../shapes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Offer = function Offer(_ref) {
  var offer = _ref.offer,
    mobileMode = _ref.mobileMode;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "offer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "term"
  }, offer.term, mobileMode ? ' mo.' : ' months'), /*#__PURE__*/_react.default.createElement("div", {
    className: "monthly-payment"
  }, "".concat(offer.minMonthlyPayments).concat(mobileMode ? '-' : ' - ').concat(offer.maxMonthlyPayments)), /*#__PURE__*/_react.default.createElement("div", {
    className: "apr"
  }, "".concat(offer.minimumApr).concat(mobileMode ? '-' : ' - ').concat(offer.maximumApr)));
};
exports.Offer = Offer;
var ADSOffer = function ADSOffer(_ref2) {
  var offer = _ref2.offer,
    mobileMode = _ref2.mobileMode,
    isLCTNI = _ref2.isLCTNI;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "offer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "term--ads"
  }, offer.term, mobileMode ? ' mo.' : ' months'), /*#__PURE__*/_react.default.createElement("div", {
    className: "monthly-payment--ads"
  }, offer.monthlyPayments), /*#__PURE__*/_react.default.createElement("div", {
    className: "apr--ads"
  }, offer.apr), !isLCTNI && /*#__PURE__*/_react.default.createElement("div", {
    className: "total-cost--ads"
  }, offer.totalCost));
};
exports.ADSOffer = ADSOffer;
var Offers = function Offers(_ref3) {
  var offers = _ref3.offers,
    productType = _ref3.productType,
    mobileMode = _ref3.mobileMode,
    monthlyIndex = _ref3.monthlyIndex;
  var isADSOffer = ['INTEREST_FREE_LOAN', 'PROMOTIONAL_RATE_PLAN'].includes(productType);
  var isLCTNI = productType === 'LC_TRUE_NO_INTEREST';
  var aprHeader = isADSOffer && !mobileMode ? 'Promotional APR' : 'APR';
  var monthlyDisclaimer = isADSOffer ? /*#__PURE__*/_react.default.createElement("span", null, "Monthly Payment ", /*#__PURE__*/_react.default.createElement("sup", null, monthlyIndex), " ") : /*#__PURE__*/_react.default.createElement("span", null, "Monthly Payment");
  if (productType === 'INTEREST_FREE_LOAN') {
    monthlyDisclaimer = /*#__PURE__*/_react.default.createElement("span", null, "Sugg. Monthly Payment ", /*#__PURE__*/_react.default.createElement("sup", null, monthlyIndex));
  }
  var className = (0, _classnames.default)('offers--display', {
    'offers--three-max': offers && offers.length <= 3
  });
  var OfferToDisplay = isADSOffer || isLCTNI ? ADSOffer : Offer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "offers__header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, "Term (Months)"), /*#__PURE__*/_react.default.createElement("div", {
    className: "offers__header__monthlyPayment"
  }, monthlyDisclaimer), /*#__PURE__*/_react.default.createElement("div", {
    className: "offers__header__apr"
  }, aprHeader), isADSOffer && /*#__PURE__*/_react.default.createElement("div", {
    className: "offers__header__totalCost"
  }, "Total Cost")), offers && offers.length ? offers.map(function (offer, idx) {
    return /*#__PURE__*/_react.default.createElement(OfferToDisplay, {
      key: idx + productType + offer.term,
      offer: offer,
      mobileMode: mobileMode,
      isLCTNI: isLCTNI
    });
  }) : null);
};
exports.Offers = Offers;
ADSOffer.propTypes = {
  offer: Shapes.ADSOffer,
  mobileMode: _propTypes.default.bool,
  isLCTNI: _propTypes.default.bool
};
Offer.propTypes = {
  offer: Shapes.Offer,
  mobileMode: _propTypes.default.bool
};
Offers.propTypes = {
  offers: _propTypes.default.arrayOf(_propTypes.default.oneOfType([Shapes.ADSOffer, Shapes.Offer])),
  productType: _propTypes.default.string,
  mobileMode: _propTypes.default.bool,
  monthlyIndex: _propTypes.default.number
};
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');